import { defineMessages } from '@formatjs/intl';

const messages = defineMessages({
	pendingHeading: {
		id: 'campaign.redemption.pending.heading',
		defaultMessage: 'Activating your offer',
		description: 'Heading shown while a card-less campaign code is being redeemed',
	},
	pendingBody: {
		id: 'campaign.redemption.pending.body',
		defaultMessage: 'This will only take a moment.',
		description: 'Body shown while a card-less campaign code is being redeemed',
	},
	alreadyHaveAccessHeading: {
		id: 'campaign.redemption.alreadyHaveAccess.heading',
		defaultMessage: 'You already have access',
		description: 'Heading when the user already has an active Calm subscription',
	},
	cannotRedeemHeading: {
		id: 'campaign.redemption.cannotRedeem.heading',
		defaultMessage: 'This offer can’t be redeemed',
		description: 'Heading when the backend refused the code (used up, expired, campaign ended, and so on)',
	},
	requestFailedHeading: {
		id: 'campaign.redemption.requestFailed.heading',
		defaultMessage: 'Something went wrong',
		description: 'Heading when the redemption request failed for a transport-level reason',
	},
	genericBody: {
		id: 'campaign.redemption.generic.body',
		defaultMessage: 'We couldn’t activate this offer.',
		description: 'Body for a refused redemption whose reason this build does not recognize',
	},
	retryBody: {
		id: 'campaign.redemption.retry.body',
		defaultMessage: 'We couldn’t activate your offer. Please try again.',
		description: 'Body when the redemption request failed and retrying may succeed',
	},
	tryAgainCta: {
		id: 'campaign.redemption.tryAgainCta',
		defaultMessage: 'Try again',
		description: 'Button that retries the redemption request',
	},
	contactPrompt: {
		id: 'campaign.redemption.contactPrompt',
		defaultMessage: 'Need help? Contact {contactEmail}.',
		description: "Prompt pointing the user to the campaign's support contact email",
	},
});

export default messages;
